import { ResponseData } from '../dtos/generic'
import { TaskWithBeneficiaryDTO } from '../dtos/task'
import { defineRoute } from './new-helpers'

export const DashboardTasksRoutes = {
  getAll: defineRoute<'GET', ResponseData<TaskWithBeneficiaryDTO[]>>({
    path: `/organizations/:organizationId/case-workers/:caseWorkerId/dashboard/tasks`,
  }),
}
